import { useLayoutEffect, useRef } from "react"

export default function useResizeObserver(targetRef, callback) {
  const observerRef = useRef(null)

  useLayoutEffect(() => {
    observerRef.current = new ResizeObserver(callback)

    const target = targetRef?.current

    if (target) {
      observerRef.current.observe(target)
    }

    return () => {
      if (target) {
        observerRef.current.unobserve(target)
      }
    }
  }, [callback, targetRef])
}
